<template>
    <main class="smaller-padding data-table">
        <v-data-table
            :headers="headers"
            :items="list"
            :total-items="30"
            :loading="loading"
            :pagination.sync="sync"
            :hide-actions="true"
            :must-sort="true"
            no-data-text="Sem dados"
            no-results-text="Sem dados"
            sort-icon="mdi-chevron-down"
        >
            <v-progress-linear
                slot="progress"
                :color="providerColor"
                indeterminate
            />

            <template slot="items" slot-scope="props">
                <app-free-connections-table-item
                    :data-item="props.item"
                ></app-free-connections-table-item>
            </template>
        </v-data-table>

        <v-pagination
            v-if="totalPages"
            v-model="sync.page"
            color="primary"
            :length="totalPages"
            @input="setPage"
        ></v-pagination>
    </main>
</template>

<script>
import EventBus from "@packages/event-bus";
import paginatedTable from "@mixins/paginated-table";
import AppFreeConnectionsTableItem from "./components/FreeConnectionsTableItem";
import provider from "@mixins/provider";

export default {
    components: {
        AppFreeConnectionsTableItem,
    },

    data() {
        return {
            entity: "freeconnections",
            headers: [
                { text: "Ação", value: "acao" },
                { text: "Aparelho", value: "nomeAparelho" },
                { text: "Descrição", value: "descricao" },
                { text: "MAC", value: "mac" },
                { text: "Edição", value: "mac" },
            ],
        };
    },

    destroyed() {
        this.$store.commit("FREECONNECTIONS_RESET_FILTERS");
    },

    mixins: [paginatedTable, provider],

    mounted() {
        this.load();
        EventBus.$on("LOAD_FREECONNECTIONS", this.load);
    },

    beforeDestroy() {
        EventBus.$off("LOAD_FREECONNECTIONS", this.load);
    },
};
</script>

<style scoped></style>
